import { toggleCollapse } from '../../../javascripts/utils/collapse';
import { t } from '../../../javascripts/utils/withTranslation';

const initTeaserCollapse = ($toggle) => {
  $toggle?.addEventListener('click', (event) => {
    toggleCollapse($toggle, {
      closedButtonText: t('Mehr Informationen'),
      openButtonText: t('Weniger Informationen'),
      toggleClass: 'icon-link',
      toggleTextClass: 'icon-link__text',
      scrollTargetClass: 'teaser',
    });
  });
};
document.querySelectorAll('.teaser__collapse-toggle').forEach(($toggle) => {
  initTeaserCollapse($toggle);
});

/**
 * Throw this custom event on the document to re-initialize the js needed for teasers (figures, copyrights, overlay-links etc.), e.g. after loading content via AJAX
 *
 * const targetScope = document.querySelector('#your-target-scope') || document;
 * const initTeaserEvents = new CustomEvent('initTeaserEvents', {
 *  bubbles: true,
 *  detail: {
 *     scope: targetScope,
 *   },
 * });
 * document.dispatchEvent(initTeaserEvents);
 */
document.addEventListener('initTeaserEvents', (event) => {
  const targetScope = event.detail.scope || document;
  const eventConfig = {
    bubbles: true,
    detail: {
      scope: targetScope,
    },
  };
  const overlayLinkInit = new CustomEvent('overlayLinkInit', eventConfig);
  const figureInit = new CustomEvent('figureInit', eventConfig);

  document.dispatchEvent(figureInit);
  document.dispatchEvent(overlayLinkInit);

  targetScope
    .querySelectorAll('.teaser__collapse-toggle')
    .forEach(($toggle) => {
      initTeaserCollapse($toggle);
    });
});

export default initTeaserCollapse;
